"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SalesDashboardReportRowDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SalesDashboardReportRowDTO, _DomainObject_1$Domai);

  function SalesDashboardReportRowDTO(id, level, isGroup, entity, title, //
  regularKpiValues, regularKpiValuesDeltas, leafletKpiValues, leafletKpiValuesDeltas, nonLeafletKpiValues, nonLeafletKpiValuesDeltas, totalKpiValues, totalKpiValuesDeltas, regNonLeafletKpiValues, regNonLeafletKpiValuesDeltas) {
    var _this;

    _classCallCheck(this, SalesDashboardReportRowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SalesDashboardReportRowDTO).call(this));
    _this.id = id;
    _this.level = level;
    _this.isGroup = isGroup;
    _this.entity = entity;
    _this.title = title;
    _this.regularKpiValues = regularKpiValues;
    _this.regularKpiValuesDeltas = regularKpiValuesDeltas;
    _this.leafletKpiValues = leafletKpiValues;
    _this.leafletKpiValuesDeltas = leafletKpiValuesDeltas;
    _this.nonLeafletKpiValues = nonLeafletKpiValues;
    _this.nonLeafletKpiValuesDeltas = nonLeafletKpiValuesDeltas;
    _this.totalKpiValues = totalKpiValues;
    _this.totalKpiValuesDeltas = totalKpiValuesDeltas;
    _this.regNonLeafletKpiValues = regNonLeafletKpiValues;
    _this.regNonLeafletKpiValuesDeltas = regNonLeafletKpiValuesDeltas;
    return _this;
  }

  return SalesDashboardReportRowDTO;
}(DomainObject_1.DomainObject);

exports.SalesDashboardReportRowDTO = SalesDashboardReportRowDTO;

SalesDashboardReportRowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SalesDashboardReportRowDTO.name);
  return {
    id: builder.str('id'),
    level: builder.num('level'),
    isGroup: builder.bool('isGroup'),
    entity: builder.opt(builder.str('entity')),
    title: builder.opt(builder.str('title')),
    regularKpiValues: builder.opt(builder.smap(builder.bigNum('regularKpiValues'))),
    regularKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('regularKpiValuesDeltas'))),
    leafletKpiValues: builder.opt(builder.smap(builder.bigNum('leafletKpiValues'))),
    leafletKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('leafletKpiValuesDeltas'))),
    nonLeafletKpiValues: builder.opt(builder.smap(builder.bigNum('nonLeafletKpiValues'))),
    nonLeafletKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('nonLeafletKpiValuesDeltas'))),
    totalKpiValues: builder.opt(builder.smap(builder.bigNum('totalKpiValues'))),
    totalKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('totalKpiValuesDeltas'))),
    regNonLeafletKpiValues: builder.opt(builder.smap(builder.bigNum('totalKpiValues'))),
    regNonLeafletKpiValuesDeltas: builder.opt(builder.smap(builder.bigNum('totalKpiValuesDeltas')))
  };
}();